/**
 * DTOs da configuração global de gamificação (GET/POST Configuration/gamification-config).
 * Consumidos pelo hook em shared e pelo cliente HTTP em core (tipos vivem aqui para evitar dependência circular).
 */

/** Máximo de dias na UI admin (3 dígitos). */
export const GAMIFICATION_VALIDITY_DAYS_MAX = 999;

export interface GamificationConfigResponse {
  pointsValidityDays: number | null;
}

export interface GamificationConfigUpdateRequest {
  pointsValidityDays: number;
}

/** Instância retornada por createGamificationConfigApi no core — usada pelo hook. */
export interface GamificationConfigApi {
  fetchGamificationConfig(): Promise<GamificationConfigResponse>;
  updateGamificationConfig(
    body: GamificationConfigUpdateRequest
  ): Promise<void>;
}
